import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import MultiInput from 'modules/core/components/MultiInput'
import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

import { capacityUnitsOptions } from '../../utils/unitsOptions'

interface Props {
  form: TimeoffCompensationForm
}

const CompensationCapacity = ({ form }: Props) => {
  const hasUnlimitedCompensation = form.get('has_unlimited_compensation')
  const compensationCapacity = form.get('compensation_capacity')

  return (
    <Box gap="s8">
      <MultiInput
        label={i18n.t(
          'time_tracking.settings.overtime.compensation.timeoff.form.content_labels.ends_at'
        )}
      >
        <Box width="s140">
          <TextField
            inputId="compensation_capacity"
            value={
              hasUnlimitedCompensation.value || compensationCapacity.value === '0'
                ? undefined
                : compensationCapacity.value
            }
            onChange={(compensation_capacity) =>
              form.setValues({
                compensation_capacity: compensation_capacity ? +compensation_capacity : undefined,
              })
            }
            hideLabel
            type="number"
            min={1}
          />
        </Box>
        <Box width="s140">
          <SelectField
            value={form.get('compensation_units').value}
            options={capacityUnitsOptions()}
            onChange={(selected) => form.setValues({ compensation_units: selected })}
            hideLabel
          />
        </Box>
      </MultiInput>
      <Text size="200">
        {i18n.t(
          'time_tracking.settings.overtime.compensation.timeoff.form.content_labels.ends_at_explanation'
        )}
      </Text>
    </Box>
  )
}

export default observer(CompensationCapacity)
